"use strict";

import $ from "jquery";
import AhoyTracker from "shared/ahoy_tracker";
import GTMTracker from "shared/gtm_tracker";
import { BugsnagAdapter } from "commons/BugsnagAdapter";
import { FeatureAttribution } from 'vidio-lite-esm'

const jsComponent = {
  has: (componentName) => {
    const component = window[componentName];
    return component && typeof component === "function";
  },
  isValid: (element) => {
    return element && element.classList.contains("js-component");
  },
  isLoaded: (element) => {
    return element.dataset["loaded"] === "true";
  },
  initialize: (element) => {
    if (!jsComponent.isValid(element)) return;
    let componentName = element.dataset.component;

    if (!jsComponent.isLoaded(element) && jsComponent.has(componentName)) {
      let component = new window[componentName]({
        $element: $(element),
        element: element,
      });

      if (typeof component["init"] === "function") {
        component.init();
      }
    }

    element.dataset.loaded = "true";
  },
};

const jsApiComponent = {
  has: (componentName) => {
    const component = window[componentName];
    return component && typeof component === "function";
  },
  isValid: (element) => {
    return element && element.classList.contains("js-api-component");
  },
  isLoaded: (element) => {
    return element.dataset["loaded"] === "true";
  },
  initialize: (element) => {
    if (!jsApiComponent.isValid(element)) return;
    let componentName = element.dataset.component;

    if (
      !jsApiComponent.isLoaded(element) &&
      jsApiComponent.has(componentName)
    ) {
      let component = new window[componentName]({
        $element: $(element),
        element: element,
      });

      if (typeof component["init"] === "function") {
        component.init();
      }
    }

    element.dataset.loaded = "true";
  },
};

const jsSectionComponent = {
  has: (componentName) => {
    const component = window[componentName];
    return component && typeof component === "function";
  },
  isValid: (element) => {
    return element && element.classList.contains("js-section-component");
  },
  isLoaded: (element) => {
    return element.dataset["loaded"] === "true";
  },
  initialize: (element) => {
    if (!jsSectionComponent.isValid(element)) return;
    let componentName = element.dataset.component;

    if (
      !jsSectionComponent.isLoaded(element) &&
      jsSectionComponent.has(componentName)
    ) {
      let component = new window[componentName]({
        $element: $(element),
        element: element,
      });

      if (typeof component["init"] === "function") {
        component.init();
      }
    }

    element.dataset.loaded = "true";
  },
};

const jsAhoy = {
  isValid: (element) => {
    return element.classList.contains("js-ahoy");
  },
};

const jsGtm = {
  isValid: (element) => {
    return element.classList.contains("js-gtm");
  },
  isLoaded: (element) => {
    return element.dataset["gtmloaded"] === "true";
  },
};

export function initJsComponent(element) {
  try {
    jsComponent.initialize(element);
  } catch (e) {
    BugsnagAdapter.notify("ComponentInitializers.initJsComponent", e);
  }
}

export function initJsApiComponent(element) {
  try {
    jsApiComponent.initialize(element);
  } catch (e) {
    BugsnagAdapter.notify("ComponentInitializers.initJsApiComponent", e);
  }
}

export function initJsSectionComponent(element) {
  try {
    jsSectionComponent.initialize(element);
  } catch (e) {
    BugsnagAdapter.notify("ComponentInitializers.initJsSectionComponent", e);
  }
}

export function initGtmComponent(element) {
  if (!jsGtm.isValid(element) || jsGtm.isLoaded(element)) return;

  new GTMTracker(element).init();
  element.dataset.gtmloaded = "true";
}

export function initAhoyComponent(element) {
  if (!jsAhoy.isValid(element)) return;

  new AhoyTracker(element).init();
}

export function initFeatureAttribution() {
  if (window.featureAttributionListenerBind) return
  
  const onClick = (e) => {
    FeatureAttribution.add({ element: e.target })
  }
  document.body.addEventListener('click', onClick)
  window.featureAttributionListenerBind = true
}

export default class ComponentInitializers {
  constructor(containerEl = document) {
    this.container = containerEl;
    this.initJsComponent();
    this.initJsGTM();
    this.initJsAhoy();
  }

  initJsComponent() {
    let elements = this.container.getElementsByClassName("js-component");

    for (var i = 0; i < elements.length; i++) {
      initJsComponent(elements[i]);
    }
  }

  static initJsApiComponent() {
    let elements = document.getElementsByClassName("js-api-component");

    for (var i = 0; i < elements.length; i++) {
      initJsApiComponent(elements[i]);
    }
  }

  static initJsSectionComponent() {
    let elements = document.getElementsByClassName("js-section-component");

    for (var i = 0; i < elements.length; i++) {
      initJsSectionComponent(elements[i]);
    }
  }

  initJsGTM() {
    let elements = this.container.getElementsByClassName("js-gtm");

    for (var i = 0; i < elements.length; i++) {
      initGtmComponent(elements[i]);
    }
  }

  initJsAhoy() {
    let elements = this.container.getElementsByClassName("js-ahoy");

    for (var i = 0; i < elements.length; i++) {
      initAhoyComponent(elements[i]);
    }
  }
}
